import {DomainObject, oneOf} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import AttachedDocument from 'shared/stores/documents/AttachedDocument';

class ReportDownload extends DomainObject {
  id;
  status;
  reportFile;

  _relations = {
    status: oneOf(['pending', 'successful', 'failed']),
    reportFile: AttachedDocument
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      status: observable,
      reportFile: observable,
      isReady: computed
    });

    this.merge(other);
  }

  get isReady() {
    return this.status === 'successful' || this.status === 'failed';
  }
}

export default ReportDownload;
